module.exports = __webpack_public_path__ + "static/media/SF_bm_sentrert_logo_moere_og_romsdal_neg.c49c104e.png";